// src/constants/Messages.ts
export const Messages = {
    error: {
        genericError:
            "Ocurrió un error de comunicación. Comprueba tu conexión a internet y vuelve a intentar.",
    },

    tiposDocumento: [
        { id: 96, value: "DNI" },
        { id: 1, value: "C.I. BS. AS." },
        { id: 25, value: "C.I. CATAMARCA" },
        { id: 16, value: "C.I. CHACO" },
        { id: 17, value: "C.I. CHUBUT" },
        { id: 3, value: "C.I. CORDOBA" },
        { id: 4, value: "C.I. CORRIENTES" },
        { id: 18, value: "C.I. FORMOSA" },
        { id: 6, value: "C.I. JUJUY" },
        { id: 21, value: "C.I. LA PAMPA" },
        { id: 8, value: "C.I. LA RIOJA" },
        { id: 7, value: "C.I. MENDOZA" },
        { id: 19, value: "C.I. MISIONES" },
        { id: 20, value: "C.I. NEUQUEN" },
        { id: 2, value: "C.I. POLICIA FEDERAL" },
        { id: 22, value: "C.I. RIO NEGRO" },
        { id: 9, value: "C.I. SALTA" },
        { id: 10, value: "C.I. SAN JUAN" },
        { id: 11, value: "C.I. SAN LUIS" },
        { id: 12, value: "C.I. SANTA FE" },
        { id: 23, value: "C.I. SANTA CRUZ" },
        { id: 13, value: "C.I. STGO. DEL ESTERO" },
        { id: 24, value: "C.I. TIERRA DEL FUEGO" },
        { id: 14, value: "C.I. TUCUMAN" },
        { id: 99, value: "DESCONOCIDO" },
        { id: 90, value: "L.C." },
        { id: 89, value: "L.E." },
        { id: 94, value: "PASAPORTE" },
    ],

    colegio: [
        { id: "AL", value: "COLEGIO DTAL DE AVELLANEDA-LANUS" },
        { id: "AZ", value: "COLEGIO DTAL DE AZUL" },
        { id: "BB", value: "COLEGIO DTAL DE BAHIA BLANCA" },
        { id: "DO", value: "COLEGIO DTAL DE DOLORES" },
        { id: "JU", value: "COLEGIO DTAL DE JUNIN" },
        { id: "LM", value: "COLEGIO DTAL DE LA MATANZA" },
        { id: "LP", value: "COLEGIO DTAL DE LA PLATA" },
        { id: "LZ", value: "COLEGIO DTAL DE LOMAS DE ZAMORA" },
        { id: "ME", value: "COLEGIO DTAL DE MERCEDES" },
        { id: "MO", value: "COLEGIO DTAL DE MORON" },
        { id: "MP", value: "COLEGIO DTAL DE MAR DEL PLATA" },
        { id: "MR", value: "COLEGIO DTAL DE MORENO-GRAL. RODRIGUEZ" },
        { id: "NC", value: "COLEGIO DTAL DE NECOCHEA" },
        { id: "PG", value: "COLEGIO DTAL DE PERGAMINO" },
        { id: "QL", value: "COLEGIO DTAL DE QUILMES" },
        { id: "SI", value: "COLEGIO DTAL DE SAN ISIDRO" },
        { id: "SM", value: "COLEGIO DTAL DE SAN MARTIN" },
        { id: "SN", value: "COLEGIO DTAL DE SAN NICOLAS" },
        { id: "TL", value: "COLEGIO DTAL DE TRENQUE LAUQUEN" },
        { id: "ZC", value: "COLEGIO DTAL DE ZARATE-CAMPANA" },
    ],

    periodos: [
        { label: "Enero", value: "01" },
        { label: "Febrero", value: "02" },
        { label: "Marzo", value: "03" },
        { label: "Abril", value: "04" },
        { label: "Mayo", value: "05" },
        { label: "Junio", value: "06" },
        { label: "Julio", value: "07" },
        { label: "Agosto", value: "08" },
        { label: "Septiembre", value: "09" },
        { label: "Octubre", value: "10" },
        { label: "Noviembre", value: "11" },
        { label: "Diciembre", value: "12" },
    ],

    estadoPago: {
        APROBADO: "APROBADO",
        PENDIENTE: "PENDIENTE",
        IMPUTADO: "IMPUTADO",
        RECHAZADO: "RECHAZADO",
    },

    tipoPago: {
        MERCADOPAGO_BOLETA: "MERCADOPAGO_BOLETA",
        MERCADOPAGO_PLAN: "MERCADOPAGO_PLAN",
        TRANSFERENCIA: "TRANSFERENCIA",
        POS: "POS",
        MANUAL: "MANUAL",
        DESCONOCIDO: "DESCONOCIDO",
    },
};
